export default __webpack_public_path__ + "static/media/b-headphone.163cf535.png";